/**
 * 0092 — filter skills/templates to the "Transcript Analysis" tag.
 * Aligns with `tasks.md` / spec: case-insensitive match on tag text.
 */

const NEEDLE = 'transcript analysis';

/**
 * Return true when the provided tag array contains the "Transcript Analysis" tag.
 *
 * Matching is case-insensitive and trims whitespace from each tag before comparing.
 *
 * @param tags - Tag array from a skill template or project skill record; may be null/undefined.
 */
export function skillTagsIncludeTranscriptAnalysis(tags: string[] | undefined | null): boolean {
  if (!tags?.length) {
    return false;
  }
  return tags.some((t) => t.trim().toLowerCase().includes(NEEDLE));
}

/** The filesystem key for the canonical bundled transcript-analysis skill template. */
export const BUNDLED_TRANSCRIPT_ANALYSIS_TEMPLATE_KEY = 'transcript-analysis';
